import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumericOnly]'
})
export class NumericOnlyDirective {

  constructor(private el: ElementRef, @Optional() private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement | null;
    const value = input?.value ?? '';
    const sanitizedValue = value
      .replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => (c.charCodeAt(0) & 0xf).toString())
      .replace(/[^0-9]/g, '');

    if (input) {
      input.value = sanitizedValue;
    }

    if (this.control?.control) {
      this.control.control.setValue(sanitizedValue, { emitEvent: false });
    }
  }
}
